import React, { memo, HTMLProps, FormEvent } from "react";
import classnames from "classnames";
import { Element } from "src/components/base";

interface IProps extends HTMLProps<HTMLInputElement> {
    type?: string;
    danger?: boolean;
    onChangeValue?: (value: string) => void;
    domRef?: any;
    classNameWrapper?: string;
}

function Input({
    type = "text",
    danger = false,
    onChangeValue,
    onChange,
    domRef,
    classNameWrapper = "",
    ...rest
}: IProps) {
    const handleChange = (e: FormEvent<HTMLInputElement>) => {
        onChange && onChange(e);
        onChangeValue && onChangeValue(e.currentTarget.value);
    };

    return (
        <Element
            className={classnames(
                "control",
                "box-border clear-both text-base relative",
                classNameWrapper
            )}
        >
            <Element
                renderAs="input"
                className={classnames(
                    "input",
                    "max-w-full w-full text-[#343a40]",
                    "is-primary",
                    {
                        ["is-danger"]: danger,
                    }
                )}
                domRef={domRef}
                type={type}
                onChange={handleChange}
                {...rest}
            />
        </Element>
    );
}

export default memo(Input);
